export enum SectionTypes {
    EDUCATION = 'education',
    EXPERIENCE = 'experience',
    SKILL = 'skill',
    CERTIFICATION = 'certificate',
    PROJECT = 'project',
    LANGUAGE = 'language',
    SHARE = 'share',
}